// extracted by mini-css-extract-plugin
module.exports = {"draggableTile":"DraggableTile_draggableTile__3NZQF","dragging":"DraggableTile_dragging__iwwTY"};